<input [(ngModel)]="date" style="width:65px !important;" (closed)="onClose()" matInput [matDatepicker]="picker"
   (dateInput)=onSelect($event) disabled />
<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
<mat-datepicker #picker startView="multi-year" (yearSelected)="chosenYearHandler($event, picker)"
   (opened)="buttonDisabled()" disabled="false">
   <mat-datepicker-actions>
      <button mat-raised-button color="primary" (click)="clearStartDate()">Reset</button>
   </mat-datepicker-actions>
</mat-datepicker>